export default __webpack_public_path__ + "static/media/BOMB.eaad086d.png";